import React from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { useAuth } from '../../contexts/AuthContext';
import axios from '../../utils/axios';

const { Title, Text } = Typography;

const Login = ({ isAdminLogin = false }) => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form] = Form.useForm();

  const loginMutation = useMutation(
    async (values) => {
      const endpoint = isAdminLogin ? '/auth/admin/login' : '/auth/login';
      const response = await axios.post(endpoint, values);
      return response.data;
    },
    {
      onSuccess: (data) => {
        login(data.token, data.user);
        message.success('Login successful!');
        
        // Redirect based on user role - check isAdmin flag or admin roles
        if (data.user.isAdmin || data.user.role === 'admin' || data.user.role === 'super_admin') {
          navigate('/admin/dashboard');
        } else {
          navigate('/client/dashboard');
        }
      },
      onError: (error) => {
        console.error('Login error:', error);
        message.error(error.response?.data?.message || 'Login failed');
      }
    }
  );

  const handleSubmit = (values) => {
    loginMutation.mutate(values);
  };

  return (
    <Card className="login-form" style={{ maxWidth: 400, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        {/* Logo */}
        <img
          src="/images/vouchain-logo.png"
          alt="Vouchain Logo"
          style={{ height: 48, marginBottom: 12 }}
        />
        {isAdminLogin ? (
          <>
            <Title level={3} style={{ margin: '2px 0', fontSize: '24px' }}>Admin Portal</Title>
            <Text type="secondary" style={{ fontSize: '14px', color: '#666' }}>Administrator Access Only</Text>
          </>
        ) : (
          <>
            <Title level={3} style={{ margin: '2px 0', fontSize: '24px' }}>Welcome Back</Title>
            <Text type="secondary" style={{ fontSize: '14px', color: '#666' }}>Sign in to your account</Text>
          </>
        )}
      </div>

      <Form
        form={form}
        name="login"
        onFinish={handleSubmit}
        layout="vertical"
        size="large"
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' }
          ]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder={isAdminLogin ? "Admin email" : "Enter your email"}
            autoComplete="email"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter your password"
            autoComplete="current-password"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loginMutation.isLoading}
          >
            {isAdminLogin ? 'Admin Sign In' : 'Sign In'}
          </Button>
        </Form.Item>
      </Form>

      <div style={{ textAlign: 'center', marginTop: 16 }}>
        {!isAdminLogin && (
          <>
            <Link to="/forgot-password">Forgot Password?</Link>
            <br />
            <span style={{ color: '#666' }}>Don't have an account? </span>
            <Link to="/register">Register here</Link>
          </>
        )}
        
        {isAdminLogin && (
          <>
            <Text type="secondary" style={{ fontSize: 12 }}>
              <Link to="/login">← Back to Client Portal</Link>
            </Text>
          </>
        )}
      </div>
    </Card>
  );
};

export default Login;
